export enum FindUserBy {
  TELEGRAM_TAG = 'telegramUsername',
  TELEGRAM_ID = 'telegramId',
  USER_ID = 'id',
}

export interface FindUserFilters {
  findUserBy: FindUserBy;
  findUserValue: string;
}
